/**
 * Utility function to handle both absolute and relative image URLs
 * @param {string} url - The image URL from the backend
 * @param {string} backendUrl - The backend base URL (optional, defaults to env var)
 * @returns {string} - The complete URL for the image
 */
export const getImageUrl = (url, backendUrl) => {
  if (!url) return '';

  // If URL is already absolute (starts with http:// or https://), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // For relative URLs, prepend the backend URL
  const baseUrl = backendUrl || process.env.REACT_APP_BACKEND_URL || '';
  return `${baseUrl}${url}`;
};
